export default __webpack_public_path__ + "static/media/Offers.8a83f7ba.svg";